
import { Base } from '../base-component';
import './switch-to-business.component.scss';

export class SwitchToBusiness extends Base {

	constructor(element: Element ) {
		super(element);
	}

	init() {}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/switch-to-business/switch-to-business.component.ts